import React from 'react';

const COLORS = ['#E74C3C', '#3498DB', '#2ECC71', '#F39C12', '#9B59B6'];

export default function BoxList({ boxes, onDelete }) {
  if (boxes.length === 0) {
    return <p style={styles.empty}>No boxes yet. Draw on the image to add one.</p>;
  }

  return (
    <ul style={styles.list}>
      {boxes.map((box, i) => (
        <li key={i} style={styles.item}>
          <span style={{ ...styles.dot, background: COLORS[i % COLORS.length] }} />
          <span style={styles.label}>{box.label}</span>
          <span style={styles.coords}>
            {(box.x * 100).toFixed(1)}%,{(box.y * 100).toFixed(1)}%&nbsp;
            {(box.w * 100).toFixed(1)}×{(box.h * 100).toFixed(1)}%
          </span>
          <button
            style={styles.deleteBtn}
            onClick={() => onDelete(i)}
            title="Remove box"
          >
            ×
          </button>
        </li>
      ))}
    </ul>
  );
}

const styles = {
  empty: { color: '#64748b', fontSize: '0.82rem', margin: 0 },
  list: { listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '6px' },
  item: {
    display: 'flex', alignItems: 'center', gap: '8px',
    background: '#0f172a', borderRadius: '6px', padding: '6px 8px',
  },
  dot: { width: '10px', height: '10px', borderRadius: '50%', flexShrink: 0 },
  label: { color: '#e2e8f0', fontSize: '0.85rem', fontWeight: 600, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  coords: { color: '#64748b', fontSize: '0.7rem', whiteSpace: 'nowrap' },
  deleteBtn: {
    background: 'transparent', border: 'none', color: '#E74C3C',
    fontSize: '1.1rem', lineHeight: 1, cursor: 'pointer', padding: '0 2px', flexShrink: 0,
  },
};
